import { render, staticRenderFns } from "./junior-home-page.vue?vue&type=template&id=dc829b12&"
import script from "./junior-home-page.vue?vue&type=script&lang=js&"
export * from "./junior-home-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports